export const detailedFreeTrialHeading = {
  productDimensions: 'Dimensions',
  freeTrialQuantity: 'Qty',
  eula: 'EULA',
  createdAt: 'Created on',
  freeTrialExpiresInDays: 'Trial Duration',
}
